import AdListingModel from "./AdListingModel";

// AJB: stuff to remove here?  Other things in the wrong file.

// AJB: singularise
interface Aspects {
  id: string;
  label: string;
  count?: number;
  children: Aspects[];
}

// AJB: this used in many places it's not ideal
class FlatAspect {
  id: string = '';
  label: string = '';
  count?: number;
  isTop?: boolean;
  level?: number = 0;
  slug?: string;
  isSelected?: boolean;
  isHorses?: boolean;
  hideFromTopNav?: boolean;
  topId?: string;
  groupLabel?: string;
  groupId?: string;
  order?: number;
}

class NumericAspect {
  value: number = -1;
  label: string = '';
}

export class ItemAttributeOption {
  value: string = '';
  label: string = '';
  group?: string;
}

class HomePageSearchResponse { // AJB: no longer just for home
  breeds: FlatAspect[] = [];
  categories: FlatAspect[] = [];
  disciplines: FlatAspect[] = [];
  locations: FlatAspect[] = [];
  colours: FlatAspect[] = [];
  genders: FlatAspect[] = [];
  riderLevels: FlatAspect[] = [];
  videoAdsCount: number = 0;
  urgentAdsCount: number = 0;
  isHorseVertical: boolean = false;
  totalResults: number = 0; // AJB: REMOVE?
  results: HomePageSearchResponseResults = new HomePageSearchResponseResults();
  selectedValuesCount: number = 0;
}

class HomePageSearchResponseResults {
  title: string = '';
  ads: AdListingModel[] = [];
  currentPage: number = 1;
  totalPages: number = 0;
  totalResults: number = 0;
  offset: number = 0;
}

class RangeAspect {
  min: number = -1;
  max: number = -1;
}

class AreaSearch {
  label: string = '';
  lat?: number;
  lon?: number;
  distance: string = '50';
}

export { HomePageSearchResponse, type Aspects, FlatAspect, NumericAspect, RangeAspect, AreaSearch };
